<template>
  <div class="backdrop" @click.self="closeModal">
    <div class="addDeviceModal">
      <form @submit.prevent="handleAddDevice">
        <label>Name</label>
        <input type="text" v-model="name" />

        <!-- <label>Category</label> -->
        <!-- <input type="text" v-model="category" /> -->

        <label>Category</label>
          <select v-model="category">
            <option value="mtb maintainance">MTB maintainance</option>
            <option value="photography">Photography</option>
            <option value="video game accessories">Video Game Accessories</option>
            <option value="other">Other</option>
          </select>

        <input type="Submit" value="Add">
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  setup(props, { emit }) {
    const deviceId = ref("");
    const name = ref("");
    const category = ref("");
    const store = useStore();

    const closeModal = () => {
      emit('close');
    };

    const handleAddDevice = () => {
      store.commit("addDevice", {
        uid: store.getters.currentUser.uid,
        //deviceId: deviceId.value,
        name: name.value,
        category: category.value,
        last_updated_date: Date.now(),
      });
      closeModal()
    };

    return {
      handleAddDevice,
      deviceId,
      name,
      category,
      closeModal,
    };
  },
};
</script>

<style>
.addDeviceModal {
  max-width: 400px;
  padding: 20px;
  margin: 100px auto;
  background: white;
  border-radius: 10px;
}
.backdrop {
  top: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.addDeviceModal h2 {
  color: #1ba098;
  border: none;
  padding: 0;
}
.addDeviceModal label {
  color: #1ba098;
  display: inline-block;
  margin: 25px 0 15px;
  font-size: 0.6em;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
}
.addDeviceModal input, select {
  display: block;
  padding: 10px 6px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid #ddd;
  color: #7f94a2;
}
.addDeviceModal select{
  background: white;
}
.addDeviceModal p {
  font-style: normal;
}
input[type="submit"] {
  background: #1ba098;
  border: 0;
  padding: 10px 20px;
  margin-top: 20px;
  color: white;
  border-radius: 20px;
}

input[type="submit"]:hover {
  background: #deb992;
  cursor: pointer;
}
</style>